import type { Api } from '@sysarb/sysarb-api';
import { Guid } from 'guid-typescript';

/**
 * Resolves the organisation node IDs a section manager has access to: the current
 * node plus all of its descendant nodes.
 */
export async function resolveSectionManagerNodeIds(api: Api, currentOrganisationNodeId: string | null): Promise<Guid[]> {
    if (currentOrganisationNodeId == null) return [];

    const currentNodeId = Guid.parse(currentOrganisationNodeId);
    const childNodes = await api.organisationNode.getChildren(currentNodeId);

    return [currentNodeId, ...(childNodes.map(node => node.id).filter(id => id != null) as Guid[])];
}
